<template>
	<div class="d-flex align-center">
		<div
			v-if="menuAddTitle"
			:style="{
				position: 'fixed',
				height: '100vh',
				width: '100vw',
				top: 0,
				left: 0,
				zIndex: indexModalIndex - 1,
				backgroundColor: 'rgba(0,0,0,0.2)'
			}"
			@click="menuAddTitle = false"
		></div>
		<v-menu
			v-model="menuAddTitle"
			offset-y
			:z-index="indexModalIndex"
			content-class="container-notification-menu-header"
			:close-on-click="false"
			:close-on-content-click="false"
			@input="changeMenu"
			v-if="section.section_type == 1"
		>
			<template v-slot:activator="{ on, attrs }">
				<v-btn
					depressed
					color="warning"
					small
					icon
					v-bind="attrs"
					v-on="on"
				>
					<v-icon small>mdi-cog</v-icon>
				</v-btn>
			</template>
			<v-card style="min-width: 300px;">
				<v-btn-toggle
					v-model="selectedTitleType"
					dense
					class="d-flex flex-row mb-3 custom-toggle-btns"
				>
					<v-btn :value="1" class="flex-grow-1"
						:color="selectedTitleType == 1 ? '#FF1209':''">
						<p class="mb-0 caption font-weight-bold" :class="selectedTitleType == 1 ? 'white--text':''">Títulos</p>
					</v-btn>
					<v-btn :value="2" class="flex-grow-1"
						:color="selectedTitleType == 2 ? '#FF1209':''">
						<p class="mb-0 caption font-weight-bold" :class="selectedTitleType == 2 ? 'white--text':''">Subtítulos</p>
					</v-btn>
				</v-btn-toggle>
				<v-card-text v-show="selectedTitleType == 1" class="px-2 py-0">
					<TitlesListingMenu
						:type="'contract'"
						:section="section"
						:showAddButton="true"
						:itemSelected="(title) => onChangeTitleMenu(title, section)"/>
				</v-card-text>
				<v-card-text v-show="selectedTitleType == 2" class="px-2 py-0">
					<TitlesListingMenu
						:type="'contract_subtitle'"
						:section="section"
						:showAddButton="true"
						:itemSelected="(title) => onChangeSubtitleMenu(title, section)"/>
				</v-card-text>
			</v-card>
		</v-menu>
	</div>
</template>

<script>
import TitlesListingMenu from '@/components/Helpers/Components/TitlesListingMenu'
import { updateContractSectionProject } from '@/helpers/api/contracts'

export default {
	name: 'ContractTitlesMenu',
	components: { TitlesListingMenu },
	props: {
		contract: {
			type: Object,
			required: true
		},
		section: {
			type: Object,
			required: true
		},
		getContractInfo: {
			type: Function,
			required: false
		},
		closeNewSection: {
			type: Function,
			required: false
		},
	},
  computed: {
		indexModalIndex(){
			const ordered = [...this.$store.state.general.openModalOrders].sort((a, b) => a - b)
			return ordered.indexOf(this.indexModal) + 10
		},
	},
	watch: {
		menuAddTitle(newValue){
			if(newValue){
				this.indexModal = + new Date()
				this.$store.commit('general/addOpenModalOrders', this.indexModal)
			}
		}
	},
	data: () => ({
		selectedTitleType: 1,
		indexModal: + new Date(),
		menuAddTitle: false,
	}),
  mounted(){
		this.$store.commit('general/addOpenModalOrders', this.indexModal)
  },
	methods: {
		changeMenu(value){
			this.menuOpen = value
		},
		closeTitleMenu(){
			this.menuAddTitle = false
		},
		async onChangeTitleMenu(title, section){
			const updateSection = {
				contract_section_id: section.id,
				title: title.title
			}
			await updateContractSectionProject(updateSection)
			this.getContractInfo && this.getContractInfo()
			this.closeNewSection && this.closeNewSection()
		},
		async onChangeSubtitleMenu(title, section){
			const updateSection = {
				contract_section_id: section.id,
				subtitle: title.subtitle
			}
			await updateContractSectionProject(updateSection)
			this.getContractInfo && this.getContractInfo()
			this.closeNewSection && this.closeNewSection()
		},
	}
}
</script>